import { z } from "zod";

export const EmailAliasCreateSchema = z.object({ recipient_id: z.string().uuid() }).strict();
export const SyntheticEmailSchema = z
  .object({
    alias: z.string().regex(/^[a-f0-9]{64}@reply\.invalid$/),
    delivery_id: z.string().uuid(),
    transport: z.enum(["generated", "mailgun_json"]).optional(),
    scenario: z.enum(["offer", "auto_reply", "untrusted"]),
  })
  .strict();
export const EmailReviewSchema = z.discriminatedUnion("decision", [
  z.object({ decision: z.literal("reject") }).strict(),
  z.object({ decision: z.literal("attach"), submission_id: z.string().uuid() }).strict(),
]);
export const EmailReceiptSchema = z
  .object({
    id: z.string().uuid(),
    recipient_id: z.string().uuid(),
    project_id: z.string().uuid(),
    status: z.enum(["pending", "rejected", "attached"]),
    synthetic: z.literal(true),
    transport: z.enum(["generated", "mailgun_json"]).optional(),
    subject: z.string(),
    body_text: z.string(),
    original: z.string(),
    attachments: z.array(
      z
        .object({
          name: z.string(),
          text: z.string(),
          base64: z.string().optional(),
          content_type: z.string().optional(),
        })
        .strict(),
    ),
    created_at: z.string(),
    reviewed_at: z.string().nullable(),
    submission_id: z.string().uuid().nullable(),
  })
  .strict();
export type EmailReceipt = z.infer<typeof EmailReceiptSchema>;
export type EmailReview = z.infer<typeof EmailReviewSchema>;
export type SyntheticEmail = z.infer<typeof SyntheticEmailSchema>;
